const TILE_NAME_FIT_MIN_PX = 10;
const STEPS_PER_PX = 2;
const TILE_NAME_EDGE_PX = 6;
const TILE_NAME_PADDING_EDGE_PX = 1;
const TILE_NEED_PAD_PX = 6;
const TILE_MONOGRAM_GAP_PX = 4;
const EDGE_EPSILON_PX = 0.05;
const TEXT_EPSILON_PX = 0.01;
const DEFAULT_TRACKING_PX = 0.45;
const PAD_VAR = "--sbf-pad";
const SIZE_VAR = "--tile-name-size";
const TRACKING_VAR = "--tile-name-tracking";
const BREAK_VAR = "--tile-name-break";
const MIN_WIDTH_VAR = "--tile-name-min-width";
const STATE_ATTR = "data-tile-name";
function nameFits(g, edge = TILE_NAME_EDGE_PX) {
  const textInside = !g.textRect || g.textRect.width <= 0 || g.textRect.left >= g.nameRect.left - TEXT_EPSILON_PX && g.textRect.right <= g.nameRect.right + TEXT_EPSILON_PX;
  return g.scrollWidth <= g.clientWidth && textInside && nameInsideTile(g.nameRect, g.tileRect, edge);
}
function nameInsideTile(nameRect, tileRect, edge = TILE_NAME_PADDING_EDGE_PX) {
  const inset = edge - EDGE_EPSILON_PX;
  return nameRect.top >= tileRect.top + inset && nameRect.bottom <= tileRect.bottom - inset && nameRect.left >= tileRect.left + inset && nameRect.right <= tileRect.right - inset;
}
function pickFitSize(base, floor, fitsAt) {
  if (fitsAt(base)) return { size: base, fits: true };
  if (base <= floor) return { size: base, fits: false };
  let lo = Math.round(floor * STEPS_PER_PX);
  if (!fitsAt(lo / STEPS_PER_PX)) return { size: lo / STEPS_PER_PX, fits: false };
  let hi = Math.ceil(base * STEPS_PER_PX) - 1;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2);
    if (fitsAt(mid / STEPS_PER_PX)) lo = mid;
    else hi = mid - 1;
  }
  return { size: lo / STEPS_PER_PX, fits: true };
}
const tiles = /* @__PURE__ */ new Set();
const dirty = /* @__PURE__ */ new Set();
let observer = null;
let flushQueued = false;
let fontsHooked = false;
function getObserver() {
  if (observer || typeof ResizeObserver === "undefined") return observer;
  observer = new ResizeObserver((entries) => {
    for (const entry of entries) markTile(entry.target);
  });
  return observer;
}
function hookFonts() {
  var _a, _b, _c;
  if (fontsHooked || typeof document === "undefined" || !document.fonts) return;
  fontsHooked = true;
  const markAll = () => tiles.forEach(markTile);
  (_a = document.fonts.ready) == null ? void 0 : _a.then(markAll).catch(() => {
  });
  (_c = (_b = document.fonts).addEventListener) == null ? void 0 : _c.call(_b, "loadingdone", markAll);
}
function markTile(tile) {
  if (!tiles.has(tile)) return;
  dirty.add(tile);
  if (flushQueued) return;
  flushQueued = true;
  queueMicrotask(flush);
}
function flush() {
  flushQueued = false;
  const due = [...dirty];
  dirty.clear();
  for (const tile of due) {
    if (tile.isConnected && tiles.has(tile)) fitTile(tile);
  }
}
function clearFit(tile) {
  tile.style.removeProperty(PAD_VAR);
  tile.style.removeProperty(SIZE_VAR);
  tile.style.removeProperty(TRACKING_VAR);
  tile.style.removeProperty(BREAK_VAR);
  tile.style.removeProperty(MIN_WIDTH_VAR);
  tile.removeAttribute(STATE_ATTR);
}
function setState(tile, state) {
  tile.setAttribute(STATE_ATTR, state);
}
function letWordsUsePadding(tile, on) {
  if (on) tile.style.setProperty(MIN_WIDTH_VAR, "auto");
  else tile.style.removeProperty(MIN_WIDTH_VAR);
}
function monogramInTheWay(btn, name, text) {
  const mark = btn.querySelector(".v2-chip, .v2-ghost");
  if (!mark) return false;
  const style = getComputedStyle(mark);
  if (style.display === "none" || style.position !== "absolute") return false;
  const m = mark.getBoundingClientRect();
  if (!(m.width > 0 && m.height > 0)) return false;
  const lines = typeof text.getClientRects === "function" ? Array.from(text.getClientRects()).filter((r) => r.width > 0) : [];
  const boxes = lines.length ? lines : [name.getBoundingClientRect()];
  const gap = TILE_MONOGRAM_GAP_PX;
  return boxes.some((r) => r.left < m.right + gap && r.right > m.left - gap && r.top < m.bottom + gap && r.bottom > m.top - gap);
}
function applyFit(tile, size, base, tracking) {
  tile.style.setProperty(SIZE_VAR, `${size}px`);
  tile.style.setProperty(TRACKING_VAR, `${(tracking * size / base).toFixed(3)}px`);
}
function fitTile(tile) {
  if (tile.closest(".drag-active")) return;
  const btn = tile.querySelector(".btn.v2");
  const name = btn == null ? void 0 : btn.querySelector(".v2-name");
  if (!btn || !name) return;
  const rect = btn.getBoundingClientRect();
  if (!(rect.width > 0 && rect.height > 0)) return;
  clearFit(tile);
  const computed = getComputedStyle(name);
  const base = parseFloat(computed.fontSize) || 0;
  if (!(base > 0)) return;
  const tracking = parseFloat(computed.letterSpacing);
  const baseTracking = Number.isFinite(tracking) ? tracking : DEFAULT_TRACKING_PX;
  const text = document.createRange();
  text.selectNodeContents(name);
  const fits = () => nameFits({
    nameRect: name.getBoundingClientRect(),
    tileRect: btn.getBoundingClientRect(),
    scrollWidth: name.scrollWidth,
    clientWidth: name.clientWidth,
    textRect: text.getBoundingClientRect()
  });
  const setSize = (s) => {
    tile.style.removeProperty(SIZE_VAR);
    tile.style.removeProperty(TRACKING_VAR);
    if (s < base) applyFit(tile, s, base, baseTracking);
  };
  if (monogramInTheWay(btn, name, text)) setState(tile, "aside");
  if (fits()) return;
  if (parseFloat(getComputedStyle(btn).paddingTop) > TILE_NEED_PAD_PX) {
    tile.style.setProperty(PAD_VAR, `${TILE_NEED_PAD_PX}px`);
  }
  const { size, fits: fitted } = pickFitSize(base, TILE_NAME_FIT_MIN_PX, (s) => {
    setSize(s);
    return fits();
  });
  setSize(size);
  if (fitted) return;
  letWordsUsePadding(tile, true);
  const tileRect = btn.getBoundingClientRect();
  const padded = name.getBoundingClientRect();
  if (nameInsideTile(padded, tileRect)) return;
  const widthFits = padded.left >= tileRect.left + TILE_NAME_PADDING_EDGE_PX - EDGE_EPSILON_PX && padded.right <= tileRect.right - TILE_NAME_PADDING_EDGE_PX + EDGE_EPSILON_PX;
  if (!widthFits) {
    letWordsUsePadding(tile, false);
    tile.style.setProperty(BREAK_VAR, "break-word");
  }
  const final = widthFits ? padded : name.getBoundingClientRect();
  if (final.top < tileRect.top - EDGE_EPSILON_PX || final.bottom > tileRect.bottom + EDGE_EPSILON_PX) {
    setState(tile, "top");
  }
}
function registerSalesTile(tile) {
  var _a;
  tiles.add(tile);
  (_a = getObserver()) == null ? void 0 : _a.observe(tile);
  hookFonts();
  markTile(tile);
}
function unregisterSalesTile(tile) {
  observer == null ? void 0 : observer.unobserve(tile);
  tiles.delete(tile);
  dirty.delete(tile);
}
function invalidateSalesTile(tile) {
  markTile(tile);
}
export {
  TILE_MONOGRAM_GAP_PX,
  TILE_NAME_EDGE_PX,
  TILE_NAME_FIT_MIN_PX,
  TILE_NAME_PADDING_EDGE_PX,
  TILE_NEED_PAD_PX,
  invalidateSalesTile,
  nameFits,
  nameInsideTile,
  pickFitSize,
  registerSalesTile,
  unregisterSalesTile
};
//# sourceMappingURL=index108.js.map
